export default class DocumentRegisterState {
	static NEW = 'NEW';
	static POSTED = 'POSTED';
	static REVERTED = 'REVERTED';
}